import { useState } from 'react';

export const usePaymentTab = <T extends string>(availableMethods: readonly T[]) => {
  const [selectedTab, setSelectedTab] = useState<T>();
  const activeTab =
    selectedTab && availableMethods.includes(selectedTab) ? selectedTab : availableMethods[0];

  return { activeTab, selectTab: setSelectedTab };
};
